import BasketProfile from 'components/Home/BasketProfileContainer';
import Button from 'components/Common/Button';
import { Divider, Typography, Box, Stack } from '@mui/material';
import DetailItem from 'components/Staff/ItemDetail';
import AssistanceFooter from 'components/Common/AssistanceFooter';
import Colors from 'constants/colors';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { formatAmount } from 'utils/helpers';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchBasketDetail, transferBasketBalance } from 'redux/slices/baskets/basketDetailsSlice';
import MuiLoader from 'components/Common/Loader';
import Routes from 'constants/routes';
import { fetchUserInfo } from 'redux/slices/user/userSlice';
import { notify } from 'components/Common/Toast';

function BasketWithdrawFundBalance() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { basketDetails, loading } = useSelector((state: RootState) => state?.baskets?.details);
    const [transferBasketLoading, setTransferBasketLoading] = useState(false);
    const { id } = useParams();
    const { balance } = basketDetails || {};

    useEffect(() => {
        if (id) {
            dispatch(fetchBasketDetail(id));
        }
    }, [id, dispatch]);

    const handleTransferBasketBalance = async () => {
        if (!id) return;
        setTransferBasketLoading(true);
        try {
            const res: any = await dispatch(transferBasketBalance({ id }));
            const { payload } = res || {};
            setTransferBasketLoading(false);
            if (payload?.code === 200) {
                notify('Fund Transfer successfully!', 'success');
                dispatch(fetchUserInfo());
                navigate(Routes.home.main);
            }
        } catch (err) {
            setTransferBasketLoading(false);
        }
    };

    return (
        <Stack direction={{ xs: 'column', lg: 'row' }}>
            <MuiLoader loading={loading} absolute />
            <Stack width="auto" alignItems="center" style={{ marginBottom: 20 }}>
                <BasketProfile basket={basketDetails} />
            </Stack>
            <Box
                sx={{
                    backgroundColor: 'white',
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 8,
                    mx: 8,
                    paddingBottom: 0,
                }}
            >
                <Typography sx={{ fontSize: 18, fontWeight: 400, mb: 1, color: Colors.darkblue }}>Withdraw Basket Balance</Typography>
                <Divider />
                <Typography sx={{ fontSize: 14, fontWeight: 400, mb: 4, mt: 2 }}>
                    Although all baskets have an automatic withdraw at the end of every week. You may choose to manually withdraw the
                    balance. Once you choose to withdraw the balance below you will see the amount deposited into your Parish Wallet
                    shortly.
                </Typography>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <div style={{ width: '22rem' }}>
                        <DetailItem labelWidth={'70%'} label={'Balance to withdraw'} value={formatAmount(basketDetails?.balance)} />
                        <DetailItem labelWidth={'70%'} label={'Transfer to'} value="Parish Wallet" />
                    </div>

                    <Button
                        disabled={!balance}
                        onClick={handleTransferBasketBalance}
                        loading={transferBasketLoading}
                        sx={{ my: 6, width: { md: '40%' } }}
                        title="Transfer Balance"
                    />
                </div>
                <AssistanceFooter type="Issue with this Transaction?" />
            </Box>
        </Stack>
    );
}

export default BasketWithdrawFundBalance;
